import React, { useRef, useState } from "react";
import useClickOutside from "../../hooks/useClickOutside";
import {
  BackButton,
  ProfileDropdown,
  QuestionIconButton,
} from "../../common/AppBarComponents";
import "../../common/AppBar.css";
import "./Products.css";

/**
 * Directory header (live mode). Left edit icon → classic AppBar; "?" is read-only (QuestionIconButton readOnly).
 */
const ProductsLiveModeAppBar = ({
  viewerName,
  onEditModeClick,
  /** Center title below “… is Viewing”. Directory uses “Directory”; Add Module passes item code (e.g. “Product …”). */
  title = "Directory",
  profileCounterBadges = { red: 5, blue: 8 },
  showBackButton = false,
  onBack,
}) => {
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const profileRef = useRef();

  useClickOutside(profileRef, () => setShowProfileDropdown(false));

  return (
    <header className="appbar products-live-appbar">
      <div className="products-live-appbar__left">
        {showBackButton && (
          <div style={{ marginRight: "25px" }}>
            <BackButton onBack={onBack} />
          </div>
        )}
        <button
          type="button"
          className="products-live-appbar__edit-mode-trigger"
          onClick={onEditModeClick}
          aria-label="Switch to edit mode"
        >
          <div className="products-live-appbar__group-wrap">
            <div className="products-live-appbar__group-circle">
              <svg
                width="18"
                height="16"
                viewBox="0 0 18 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M9.6155 15.8077V13.1655L15.0443 7.7615C15.1686 7.64367 15.3028 7.55783 15.447 7.504C15.5912 7.45017 15.7353 7.42325 15.8795 7.42325C16.0367 7.42325 16.1888 7.45267 16.3358 7.5115C16.4827 7.5705 16.6163 7.659 16.7365 7.777L17.6615 8.7115C17.7692 8.836 17.8525 8.97067 17.9115 9.1155C17.9705 9.26033 18 9.40517 18 9.55C18 9.69483 17.9747 9.84225 17.924 9.99225C17.8733 10.1423 17.7858 10.2794 17.6615 10.4038L12.2578 15.8077H9.6155ZM0 14.6155V12.3923C0 11.9026 0.133 11.4491 0.399 11.0317C0.665 10.6144 1.0205 10.2936 1.4655 10.0693C2.45383 9.58475 3.45092 9.22133 4.45675 8.979C5.46258 8.73667 6.477 8.6155 7.5 8.6155C8.03333 8.6155 8.56317 8.64817 9.0895 8.7135C9.61567 8.77883 10.1435 8.87883 10.673 9.0135L7.423 12.254V14.6155H0ZM15.8828 10.5155L16.8078 9.55L15.8828 8.6155L14.9327 9.5655L15.8828 10.5155ZM7.5 7C6.5375 7 5.71358 6.65733 5.02825 5.972C4.34275 5.2865 4 4.4625 4 3.5C4 2.5375 4.34275 1.71358 5.02825 1.02825C5.71358 0.34275 6.5375 0 7.5 0C8.4625 0 9.28642 0.34275 9.97175 1.02825C10.6573 1.71358 11 2.5375 11 3.5C11 4.4625 10.6573 5.2865 9.97175 5.972C9.28642 6.65733 8.4625 7 7.5 7Z"
                  fill="#0D6EFD"
                />
              </svg>
            </div>
          </div>
        </button>
      </div>

      <div className="products-live-appbar__center">
        <div className="products-live-appbar__viewer">
          {viewerName} is Viewing
        </div>
        <div className="products-live-appbar__title">{title}</div>
      </div>

      <div className="products-live-appbar__right">
        <QuestionIconButton readOnly />
        <ProfileDropdown
          showProfileDropdown={showProfileDropdown}
          setShowProfileDropdown={setShowProfileDropdown}
          profileRef={profileRef}
          showProfileButton={true}
          counterBadges={profileCounterBadges}
          compactLiveDirectory
        />
      </div>
    </header>
  );
};

export default ProductsLiveModeAppBar;
